import React, { useState, useEffect } from "react";
import PensionForm1 from "./pensionForm1";
import PensionFormMar from "./pensionForm1Marathi";
import PensionForm2 from "./pensionForm2";
import PensionForm3 from "./pensionForm3";
import PensionForm4 from "./pensionForm4";
import PensionForm5 from "./pensionForm5";
import PensionForm6 from "./pensionForm6";

import { useFormSubmission } from "../../pages/payment/customPayment";
import Swal from 'sweetalert2';
import {
  handleFormDataChange,
  handleNextStep,
  handlePreviousStep,
  
} from "../../components/formHandlers"; 
import "../../../style/google_forms.css"; 





const PensionForm = () => {

  const initialFormState = {
    //Form 1
    employeeName: '',
    fatherName: '',
    email: '',
    phoneNumber: '',
    address: '',
    gender: '',
    nationality: '',
    religion: '',
    designation: '',
    Height: '',
    splMark: '',
    dateOfBirth: '',
    adharno: '',
    panno: '',
    employeecode: '',
    pfno: '',
    dateOfAppointment: '',
    dateOfService: '',
    dateOfRetirement: '',
    typeOfRetirement: '',
    classOfPost: '',
    placeOfRetirement: '',

    //Marathi Input
    employeeNameMar: '',
    institutionNameMar: '',
    designationMar: '',
    regionMar: '',
    regionalPlaceMar: '',

    //Form 2
    spouseName: '',
    spouseDOB: '',
    spouceRelation: '',
    childDetails: [],

    //Form 3
    bankName: '',
    branchName: '',
    accountNumber: '',
    ifscCode: '',
    
    //Form 4
    institutionName: '',
    establishmentDate: '',
    aidedDate: '',
    managementName: '',
    region: '',
    city: '',
    treasury: '',
    educationOfficer: '',
    ddoCode: '',
    ddoretired: '',
    todcrg: '',

    //Form 5
    nonQualifyServiceYears: '',
    nonQualifyServiceMonths: '',
    nonQualifyServiceDays: '',
    qualifyServiceYears: '',

    //Form 6
    payLevel: '',
    payrateTable: [],
    basicPay: '',
    notionalPay: '',
    DA: '',
    HRA: '',
    TRA: '',
    CLA: '',
    splPay: '',
  };
  // const dummyFormData = {
  //   // Form 1
  //   employeeName: 'Madhuri Dixit',
  //   fatherName: 'Rajesh Khanna',
  //   email: 'rajesh.kumar@example.com',
  //   phoneNumber: '9876543210',
  //   address: '159 Guruwar Peth, Satara',
  //   gender: 'Male',
  //   nationality: 'Indian',
  //   religion: 'Hindu',
  //   designation: 'Clerk',
  //   Height: '5ft 9in',
  //   splMark: 'Mole on right hand',
  //   dateOfBirth: '1965-08-15',
  //   adharno: '123456789012',
  //   panno: 'ABCDE1234F',
  //   employeecode: 'EMP456789',
  //   pfno: 'PF123456',
  //   dateOfAppointment: '1989-06-01',
  //   dateOfService: '1990-01-01',
  //   dateOfRetirement: '2025-03-31',
  //   typeOfRetirement: 'Superannuation Retirement',
  //   classOfPost: 'III',
  //   placeOfRetirement: 'Satara',
  
  //   //MarathiInp
  // employeeNameMar: 'सुभाष माने',
  // institutionNameMar: 'शासकीय तंत्रनिकेतन, पुणे',
  // designationMar: 'वरिष्ठ लिपिक',
  // regionMar: 'पश्चिम महाराष्ट्र',
  // regionalPlaceMar: 'पुणे',

  //   // Form 2
  //   spouseName: 'Sangeeta Kumari',
  //   spouseDOB: '1968-10-20',
  //   spouceRelation: 'Wife',
  //   childDetails: [
  //     { name: 'Amit Kumar', dob: '1995-05-12', relationship: 'Son' },
  //     { name: 'Neha Kumari', dob: '1998-09-23', relationship: 'Daughter' }
  //   ],
  
  //   // Form 3
  //   bankName: 'State Bank of India',
  //   branchName: 'Satara Main Branch',
  //   accountNumber: '123456789012',
  //   ifscCode: 'SBIN0000123',
  
  //   // Form 4
  //   institutionName: 'New English School',
  //   establishmentDate: '1990-01-01',
  //   aidedDate: '1995-01-01',
  //   managementName: 'Satara Education Society',
  //   region: 'Kolhapur Region',
  //   city: 'Kolhapur',
  //   treasury: 'Satara Treasury Office',
  //   educationOfficer: 'Mr. A.B. Pawar',
  //   ddoCode: 'DDO1234',
  //   ddoretired: '2025-03-31',
  //   todcrg: '100000',
  
  //   // Form 5
  //   nonQualifyServiceYears: '2',
  //   nonQualifyServiceMonths: '4',
  //   nonQualifyServiceDays: '15',
  //   qualifyServiceYears: '33',
  
  //   // Form 6
  //   payLevel: 'S-1',
  //   payrateTable: [
  //     { from: "2019-06-1", to: "2020-02-29", payrate: 1500 },
  //   { from: "2020-03-01", to: "2020-03-31", payrate: 1800 }
  //   ],
  //   basicPay: '44900',
  //   DA: '7633',
  //   HRA: '5388',
  //   TRA: '1800',
  //   CLA: '200',
  //   splPay: '0',
  // };
  
  const dummyFormData2 = {
  

  // Form 1
  employeeName: "Shri Kamalakar Ramchandra Gharge",
  fatherName: "Late Shri Ramchandra Mugutrao Gharge",
  email: "survecsc@gmail.com",
  phoneNumber: "9881373689",
  address: "At Post, Vadgaon(J.S.), Tal: Khatav, Dist: Satara, PIN : 415512",
  gender: "Male",
  nationality: "Indian",
  religion: "Hindu-Maratha",
  designation: "Head Master",
  Height: "5 feet 5 inch",
  splMark: "Amole on chest on left and right side",
  dateOfBirth: "1968-06-02",
  adharno: "748778125128",
  panno: "ABKPG5139P",
  employeecode: "04DEDKRGM6802",
  pfno: "SATARA/15620",
  dateOfAppointment: "1992-06-18",
  dateOfService: "1994-06-18",
  dateOfRetirement: "2026-06-30",
  typeOfRetirement: "Superannuation Retirement",
  classOfPost: "3",
  placeOfRetirement: "Pusesawali",

  // Marathi Input
  employeeNameMar: "श्री कमलाकर रामचंद्र घार्गे",
  institutionNameMar:
    "महात्मा गांधी विद्यालय व ज्युनिअर कॉलेज , पुसेसावळी , ता:खटाव, जि: सातारा",
  designationMar: "मुख्याध्यापक",
  regionMar: "सातारा",
  regionalPlaceMar: "सातारा",

  // Form 2
  spouseName: "Sou. Sunita Kamalakar Gharge",
  spouseDOB: "1976-08-18",
  spouceRelation: "Wife",
  childDetails: [
    {
      nameChild: "Shri Akshay Kamalakar Gharge",
      dobChild: "1997-06-01",
      relationship: "Son"
    },
    {
      nameChild: "Shri Ashish Kamalakar Gharge",
      dobChild: "1999-02-14",
      relationship: "Son"
    }
  ],

  // Form 3
  bankName: "State Bank Of India",
  branchName: "Pusesawali",
  accountNumber: "123456789012",
  ifscCode: "SBIN0011490",

  // Form 4
  institutionName: "Mahatma Gandhi Vidyalay and Jr. College, Pusesawali",
  establishmentDate: "1966-06-01",
  aidedDate: "1966-06-01",
  managementName: "Shikshan Prasarak Mandal Bhag Pusesawali",
  region: "Satara",
  city: "Satara",
  treasury: "Satara",
  educationOfficer: "Satara",
  ddoCode: "04230100724",
  ddoretired: "Satara",
  todcrg: "Satara",

  // Form 5
  nonQualifyServiceYears: "0",
  nonQualifyServiceMonths: "0",
  nonQualifyServiceDays: "0",

  // Form 6
  payLevel: "S-18",
  basicPay: 91500,
  notionalPay: 94200,
  payrateTable: [
    {
      from: "2025-09-01",
      to: "2026-06-30",
      payrate: 91500
    }
  ],
  DA: 50325,
  HRA: 9148,
  TRA: 1350,
  CLA: 0,
  splPay: 0,

  // Calculations
  calculation: [
    {
      grossService: { years: 34, months: 0, days: 13 },
      pensionableService: { years: 34, months: 0, days: 13 },
      terms: 66,
      gratuityFactor: 16.5,
      commutationFactor: 8.446,
      PensionablePayAvg: {
        total1: 915000,
        total2: 0,
        period1: {
          Dfirst: 0,
          Dfrac1: 0,
          Dsecond: 0,
          Dfrac2: 0,
          months: 10
        },
        period2: null,
        netTotal: 915000
      }
    }
  ],

  pension: 0,
  pensionablePay: 0,
  commutedPension: 0
};


 const [formData, setFormData] = useState(initialFormState);
   const { handleFormSubmission, isSubmitting, PaymentWindowComponent  } = useFormSubmission();
 
  
  const [step, setStep] = useState(1);

  const handleNext = () => {
    handleNextStep(setStep);
  };

  const handleBack = () => {
    handlePreviousStep(setStep);
  };


  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/pensionsr/submit-pension`,
    paymentDescription: "Payment for Pension Case Documents",
    successRoute: "/pensionsr/pensionCase-result",
    name: formData.employeeName,
    formType: "Senior Pension Case",
    email: formData.email,
    contact: formData.phoneNumber,
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.employeeName || !formData.email || !formData.phoneNumber) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Required Fields',
        text: 'Please fill all required fields before submitting.'
      });
      return;
    }     
      // Submit after state update
      handleFormSubmission(formData, formConfig);

  };
  
  


  useEffect(() => {
    try {
      const savedFormData = JSON.parse(localStorage.getItem("formData"));
      if (savedFormData) {
        setFormData((prev) => ({ ...prev, ...savedFormData }));
      }
    } catch (err) {
      console.error("Failed to parse formData from localStorage", err);
    }
  }, []);
  
  

  return (
    <div>
      {step === 1 && (
        <PensionForm1
          formData={formData}
          setFormData={setFormData}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}
        {step === 2 && (
        <PensionFormMar
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}
    {step === 3 && (
        <PensionForm2
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 4 && (
        <PensionForm3
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 5 && (
        <PensionForm4
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 6 && (
        <PensionForm5
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 7 && (
        <PensionForm6
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onSubmit={handleSubmit}
        />
      )}
    {PaymentWindowComponent}

    </div>
  );
};

export default PensionForm;
